<div class="astrea-active-session m-sm-4 m-2">
    <div class="container t-center">

        <h1>⚠️ Tu cuenta está en uso en otro dispositivo</h1>

        <p>Detectamos que tu cuenta estuvo recientemente activa en otro navegador o dispositivo.</p>

        <p>La suscripción a Astrea Virtual <strong>solo permite acceso a leer obras en un solo dispositivo a la vez en un lapso de 30 minutos.</strong></p>

        <p>Si querés usar este dispositivo, por favor cerrá cualquier otra sesión que tengas activa.</p>

        <p>Si no fuiste vos o no reconoces esta actividad, te recomendamos cambiar tu contraseña inmediatamente.</p>

        <small>¡Muchas gracias por tu compresión!</small>

        <div>
            <a (click)="logoutSessions()">
                Cerrar sesión en todos los dispositivos
            </a>
        </div>

    </div>
</div>
